/**
 * Creates a new Logout object.
 * @class Logout
 */
class Logout {

  /**
   * Initialize object properties and options.
   */
  constructor(logoutButton, logoutPopover) {
    /**
     * Initialize the Logout object with all of its object elements.
     * @param {Object} logoutButton - The loggout button element `<button>`.
     * @param {Object} logoutPopover - The logout popover with clickable logout link.
     */
    this.logoutButton = logoutButton;
    this.logoutPopover = logoutPopover;

    /* Object property that gets/sets responsive breakpoints (screen sizes). */
    this.screen = undefined;
  }

  /**
   * Initialize the logout toggle button (element that shows user name and down caret).
   */
  initToggleLogout() {
    /* On click listener, toggle open/close class on logout link. */
    this.logoutButton.on( 'click', function(e) {
      e.preventDefault();
      this.logoutPopover.toggleClass( 'open' );
    }.bind( this )); // Bind the class object to maintain context.

    return;
  }

  /**
   * Initialize logout popover.
   * This method calculates the absolute right position of the logout popover
   * in relation to the logout toggler button.
   */
  initPopover() {
    if (this.logoutButton.length !== 0) {
      /* Set the variables for calculating the right position of the popover. */
      let buttonLeftPosition = parseFloat( this.logoutButton.offset().left );
      let buttonWidth = parseFloat( this.logoutButton.outerWidth( true ) );
      let rightPosition = (($( window ).width() - (buttonLeftPosition + buttonWidth)) + 15); // 15 is the right offset between parent and child to replicate Nova positioning

      /* Dynamically set the logout popover's right position. */
      this.logoutPopover.css( '--calculated-logout-right-position', rightPosition + 'px' );
    }

    return;
  }

  /**
   * Handle page resize callbacks.
   */
  handleResize() {
    /* Close any open nav elements. */
    this.logoutPopover.removeClass( 'open' );

    /* Re-calculate the logout popover's right position. */
    this.initPopover();

    return;
  }

  /**
   * Method callback to initialize the Logout object.
   */
  init() {
    this.initToggleLogout();
    this.initPopover();

    /* Add window resize listener with debounce. */
    $( window ).on( 'resize', function() {
      setTimeout( this.handleResize(), 500 );
    }.bind( this )); // Bind the class object to maintain context.
  }
}

/* Export the class as default. */
export default Logout;
